// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CampaignDetailQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CampaignDetailQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'immediateUsersCount' | 'scheduledActionsCountUntilNow' | 'canBeActivated' | 'hasCorrectActionScheduleTypes' | 'actionsInThePastCount' | 'wasCampaignDeactivated' | 'is_active' | 'status' | 'audience_check_runs_since' | 'last_completed_audience_check' | 'name' | 'organisation_id' | 'schedule_type' | 'updated_at' | 'user_id' | 'archived_at' | 'track_links'>
      & { audienceJoinEventsCount: PrivateSchemaTypes.CampaignModelAsAdminQueries['audienceEventsCount'], audienceCompletedCount: PrivateSchemaTypes.CampaignModelAsAdminQueries['audienceEventsCount'] }
      & { banners: Array<(
        { __typename?: 'CampaignBannerModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignBannerModelAsEditor, 'id' | 'header' | 'fixed_show_time_start' | 'fixed_show_time_end' | 'show_at_day' | 'show_at_time' | 'hide_at_day' | 'hide_at_time' | 'timezone' | 'uniqueViewCount' | 'uniqueClickCount' | 'button_link' | 'button_caption' | 'text' | 'effectiveness'>
        & { image?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'DocumentModel' }
          & Pick<PrivateSchemaTypes.DocumentModel, 'cdnUrl'>
          & { imageVariants: Array<(
            { __typename?: 'ImageVariantModel' }
            & Pick<PrivateSchemaTypes.ImageVariantModel, 'cdnUrl'>
          )> }
        )> }
      )>, emailActions: Array<(
        { __typename?: 'CampaignEmailActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignEmailActionModelAsEditor, 'id' | 'fixed_send_time' | 'send_at_day' | 'send_at_time' | 'subject' | 'viewCount' | 'sentCount' | 'uniqueClickCount' | 'effectiveness' | 'button_caption' | 'button_link' | 'campaign_id' | 'text' | 'timezone' | 'trackedLinksCount' | 'automatic_time_of_day' | 'respect_business_hours' | 'is_for_manager' | 'email_identity_id'>
        & { image?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'ImageWithVariants' }
          & Pick<PrivateSchemaTypes.ImageWithVariants, 'variants'>
          & { original: PrivateSchemaTypes.ImageWithVariants['originalCdnUrl'] }
        )>, emailIdentity?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'EmailIdentityModel' }
          & Pick<PrivateSchemaTypes.EmailIdentityModel, 'name'>
        )> }
      )>, filters: Array<(
        { __typename?: 'CampaignFilter' }
        & Pick<PrivateSchemaTypes.CampaignFilter, 'created_at' | 'created_by' | 'ref_ids' | 'type'>
        & { comparator?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UserFilterComparator' }
          & Pick<PrivateSchemaTypes.UserFilterComparator, 'value' | 'field' | 'operator'>
        )>, enrolmentFilterSetup?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignEnrolmentFilterSetup' }
          & Pick<PrivateSchemaTypes.CampaignEnrolmentFilterSetup, 'enrolmentFilterType' | 'includeArchived' | 'creationMethod'>
        )>, eventFilterSetup?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'CampaignEventFilterSetup' }
          & Pick<PrivateSchemaTypes.CampaignEventFilterSetup, 'eventFilterType' | 'eventIds' | 'recurringEventIds'>
        )>, temporalComparator?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TimeComparatorForEnrolment' }
          & Pick<PrivateSchemaTypes.TimeComparatorForEnrolment, 'field'>
          & { relative?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'RelativeTimeComparator' }
            & Pick<PrivateSchemaTypes.RelativeTimeComparator, 'direction'>
            & { duration?: PrivateSchemaTypes.Maybe<(
              { __typename?: 'UserFilterTimeDuration' }
              & Pick<PrivateSchemaTypes.UserFilterTimeDuration, 'multiplier' | 'unit'>
            )> }
          )>, static?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'StaticTimeComparator' }
            & Pick<PrivateSchemaTypes.StaticTimeComparator, 'direction' | 'date'>
          )>, range?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'RangeTimeComparator' }
            & Pick<PrivateSchemaTypes.RangeTimeComparator, 'fromDate' | 'toDate'>
          )> }
        )> }
      )>, topicShareActions: Array<(
        { __typename?: 'CampaignTopicShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignTopicShareActionModelAsEditor, 'id' | 'text' | 'send_at_time' | 'fixed_send_time' | 'send_share_email' | 'send_at_day' | 'timezone' | 'target_completion_date' | 'reset_existing_enrolments' | 'relative_target_completion_day' | 'relative_target_completion_time' | 'sharedCount' | 'completedCount' | 'effectiveness' | 'trackedLinksCount' | 'automatic_time_of_day' | 'respect_business_hours' | 'email_identity_id'>
        & { actionTopics: Array<(
          { __typename?: 'CampaignActionTopicModel' }
          & Pick<PrivateSchemaTypes.CampaignActionTopicModel, 'id'>
          & { topic: (
            { __typename?: 'TopicModelAsEditor' }
            & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id' | 'currentTitle'>
          ) }
        )>, emailIdentity?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'EmailIdentityModel' }
          & Pick<PrivateSchemaTypes.EmailIdentityModel, 'name'>
        )> }
      )>, pathwayShareActions: Array<(
        { __typename?: 'CampaignPathwayShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignPathwayShareActionModelAsEditor, 'id' | 'text' | 'send_at_time' | 'fixed_send_time' | 'send_share_email' | 'send_at_day' | 'timezone' | 'target_completion_date' | 'reset_existing_enrolments' | 'relative_target_completion_day' | 'relative_target_completion_time' | 'sharedCount' | 'completedCount' | 'effectiveness' | 'trackedLinksCount' | 'automatic_time_of_day' | 'respect_business_hours' | 'email_identity_id'>
        & { actionPathways: Array<(
          { __typename?: 'CampaignActionPathwayModel' }
          & Pick<PrivateSchemaTypes.CampaignActionPathwayModel, 'id'>
          & { pathway: (
            { __typename?: 'PathwayModelAsAdmin' }
            & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'title'>
          ) }
        )>, emailIdentity?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'EmailIdentityModel' }
          & Pick<PrivateSchemaTypes.EmailIdentityModel, 'name'>
        )> }
      )>, certificationShareActions: Array<(
        { __typename?: 'CampaignCertificationShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignCertificationShareActionModelAsEditor, 'id' | 'text' | 'send_at_time' | 'fixed_send_time' | 'send_share_email' | 'send_at_day' | 'timezone' | 'target_completion_date' | 'reset_existing_enrolments' | 'relative_target_completion_day' | 'relative_target_completion_time' | 'sharedCount' | 'completedCount' | 'effectiveness' | 'trackedLinksCount' | 'automatic_time_of_day' | 'respect_business_hours' | 'email_identity_id'>
        & { actionCertifications: Array<(
          { __typename?: 'CampaignActionCertificationModel' }
          & Pick<PrivateSchemaTypes.CampaignActionCertificationModel, 'id'>
          & { certification: (
            { __typename?: 'CertificationModelAsAdmin' }
            & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'name'>
          ) }
        )>, emailIdentity?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'EmailIdentityModel' }
          & Pick<PrivateSchemaTypes.EmailIdentityModel, 'name'>
        )> }
      )>, surveyShareActions: Array<(
        { __typename?: 'CampaignSurveyShareActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignSurveyShareActionModelAsEditor, 'id' | 'text' | 'send_at_time' | 'fixed_send_time' | 'send_at_day' | 'timezone' | 'sharedCount' | 'completedCount' | 'effectiveness' | 'trackedLinksCount' | 'send_share_email' | 'automatic_time_of_day' | 'respect_business_hours' | 'email_identity_id'>
        & { actionSurveys: Array<(
          { __typename?: 'CampaignActionSurveyModel' }
          & Pick<PrivateSchemaTypes.CampaignActionSurveyModel, 'id'>
          & { survey: (
            { __typename?: 'SurveyModel' }
            & Pick<PrivateSchemaTypes.SurveyModel, 'id' | 'title'>
          ) }
        )>, emailIdentity?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'EmailIdentityModel' }
          & Pick<PrivateSchemaTypes.EmailIdentityModel, 'name'>
        )> }
      )>, messageActions: Array<(
        { __typename?: 'CampaignMessageActionModelAsEditor' }
        & Pick<PrivateSchemaTypes.CampaignMessageActionModelAsEditor, 'id' | 'fixed_send_time' | 'send_at_day' | 'send_at_time' | 'campaign_id' | 'text' | 'timezone' | 'type' | 'sentCount' | 'failedCount' | 'trackedLinksCount' | 'automatic_time_of_day' | 'respect_business_hours'>
      )> }
    )> }
  )> }
);

export type CampaignDefaultSenderQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type CampaignDefaultSenderQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id'>
      & { defaultEmailIdentity?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'EmailIdentityModel' }
        & Pick<PrivateSchemaTypes.EmailIdentityModel, 'id'>
      )> }
    )> }
  )> }
);

export type FixedActionsComingUpInActivationWindowQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type FixedActionsComingUpInActivationWindowQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminQueries' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'activationWindowDuration'>
      & { fixedActionsComingUpInActivationWindow: Array<(
        { __typename?: 'CampaignActionBaseModel' }
        & Pick<PrivateSchemaTypes.CampaignActionBaseModel, 'id' | 'fixed_send_time'>
      )> }
    )> }
  )> }
);


export const CampaignDetailDocument = gql`
    query campaignDetail($id: PositiveInt!) {
  admin {
    campaign(id: $id) {
      id
      audienceJoinEventsCount: audienceEventsCount(statuses: [join])
      audienceCompletedCount: audienceEventsCount(statuses: [completed])
      immediateUsersCount
      scheduledActionsCountUntilNow
      canBeActivated
      hasCorrectActionScheduleTypes
      actionsInThePastCount
      wasCampaignDeactivated
      is_active
      status
      audience_check_runs_since
      last_completed_audience_check
      name
      organisation_id
      schedule_type
      updated_at
      user_id
      archived_at
      track_links
      banners {
        id
        header
        fixed_show_time_start
        fixed_show_time_end
        show_at_day
        show_at_time
        hide_at_day
        hide_at_time
        timezone
        uniqueViewCount
        uniqueClickCount
        button_link
        button_caption
        text
        effectiveness
        image {
          cdnUrl
          imageVariants {
            cdnUrl
          }
        }
      }
      emailActions {
        id
        image {
          original: originalCdnUrl
          variants
        }
        fixed_send_time
        send_at_day
        send_at_time
        subject
        viewCount
        sentCount
        uniqueClickCount
        effectiveness
        button_caption
        button_link
        campaign_id
        text
        timezone
        trackedLinksCount
        automatic_time_of_day
        respect_business_hours
        is_for_manager
        email_identity_id
        emailIdentity {
          name
        }
      }
      filters {
        comparator {
          value
          field
          operator
        }
        enrolmentFilterSetup {
          enrolmentFilterType
          includeArchived
          creationMethod
        }
        eventFilterSetup {
          eventFilterType
          eventIds
          recurringEventIds
        }
        temporalComparator {
          field
          relative {
            direction
            duration {
              multiplier
              unit
            }
          }
          static {
            direction
            date
          }
          range {
            fromDate
            toDate
          }
        }
        created_at
        created_by
        ref_ids
        type
      }
      topicShareActions {
        id
        text
        send_at_time
        fixed_send_time
        send_share_email
        send_at_day
        timezone
        target_completion_date
        reset_existing_enrolments
        relative_target_completion_day
        relative_target_completion_time
        sharedCount
        completedCount
        effectiveness
        trackedLinksCount
        actionTopics {
          id
          topic {
            id
            currentTitle
          }
        }
        automatic_time_of_day
        respect_business_hours
        email_identity_id
        emailIdentity {
          name
        }
      }
      pathwayShareActions {
        id
        text
        send_at_time
        fixed_send_time
        send_share_email
        send_at_day
        timezone
        target_completion_date
        reset_existing_enrolments
        relative_target_completion_day
        relative_target_completion_time
        sharedCount
        completedCount
        effectiveness
        trackedLinksCount
        actionPathways {
          id
          pathway {
            id
            title
          }
        }
        automatic_time_of_day
        respect_business_hours
        email_identity_id
        emailIdentity {
          name
        }
      }
      certificationShareActions {
        id
        text
        send_at_time
        fixed_send_time
        send_share_email
        send_at_day
        timezone
        target_completion_date
        reset_existing_enrolments
        relative_target_completion_day
        relative_target_completion_time
        sharedCount
        completedCount
        effectiveness
        trackedLinksCount
        actionCertifications {
          id
          certification {
            id
            name
          }
        }
        automatic_time_of_day
        respect_business_hours
        email_identity_id
        emailIdentity {
          name
        }
      }
      surveyShareActions {
        id
        text
        send_at_time
        fixed_send_time
        send_at_day
        timezone
        sharedCount
        completedCount
        effectiveness
        trackedLinksCount
        send_share_email
        actionSurveys {
          id
          survey {
            id
            title
          }
        }
        automatic_time_of_day
        respect_business_hours
        email_identity_id
        emailIdentity {
          name
        }
      }
      messageActions {
        id
        fixed_send_time
        send_at_day
        send_at_time
        campaign_id
        text
        timezone
        type
        sentCount
        failedCount
        trackedLinksCount
        automatic_time_of_day
        respect_business_hours
      }
    }
  }
}
    `;

/**
 * __useCampaignDetailQuery__
 *
 * To run a query within a React component, call `useCampaignDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignDetailQuery, CampaignDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignDetailQuery, CampaignDetailQueryVariables>(CampaignDetailDocument, options);
      }
export function useCampaignDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignDetailQuery, CampaignDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignDetailQuery, CampaignDetailQueryVariables>(CampaignDetailDocument, options);
        }
export type CampaignDetailQueryHookResult = ReturnType<typeof useCampaignDetailQuery>;
export type CampaignDetailLazyQueryHookResult = ReturnType<typeof useCampaignDetailLazyQuery>;
export type CampaignDetailQueryResult = Apollo.QueryResult<CampaignDetailQuery, CampaignDetailQueryVariables>;
export const CampaignDefaultSenderDocument = gql`
    query campaignDefaultSender($id: PositiveInt!) {
  admin {
    campaign(id: $id) {
      id
      defaultEmailIdentity {
        id
      }
    }
  }
}
    `;

/**
 * __useCampaignDefaultSenderQuery__
 *
 * To run a query within a React component, call `useCampaignDefaultSenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDefaultSenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDefaultSenderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignDefaultSenderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CampaignDefaultSenderQuery, CampaignDefaultSenderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CampaignDefaultSenderQuery, CampaignDefaultSenderQueryVariables>(CampaignDefaultSenderDocument, options);
      }
export function useCampaignDefaultSenderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CampaignDefaultSenderQuery, CampaignDefaultSenderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CampaignDefaultSenderQuery, CampaignDefaultSenderQueryVariables>(CampaignDefaultSenderDocument, options);
        }
export type CampaignDefaultSenderQueryHookResult = ReturnType<typeof useCampaignDefaultSenderQuery>;
export type CampaignDefaultSenderLazyQueryHookResult = ReturnType<typeof useCampaignDefaultSenderLazyQuery>;
export type CampaignDefaultSenderQueryResult = Apollo.QueryResult<CampaignDefaultSenderQuery, CampaignDefaultSenderQueryVariables>;
export const FixedActionsComingUpInActivationWindowDocument = gql`
    query fixedActionsComingUpInActivationWindow($id: PositiveInt!) {
  admin {
    campaign(id: $id) {
      id
      fixedActionsComingUpInActivationWindow {
        id
        fixed_send_time
      }
      activationWindowDuration
    }
  }
}
    `;

/**
 * __useFixedActionsComingUpInActivationWindowQuery__
 *
 * To run a query within a React component, call `useFixedActionsComingUpInActivationWindowQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixedActionsComingUpInActivationWindowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixedActionsComingUpInActivationWindowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFixedActionsComingUpInActivationWindowQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FixedActionsComingUpInActivationWindowQuery, FixedActionsComingUpInActivationWindowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FixedActionsComingUpInActivationWindowQuery, FixedActionsComingUpInActivationWindowQueryVariables>(FixedActionsComingUpInActivationWindowDocument, options);
      }
export function useFixedActionsComingUpInActivationWindowLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FixedActionsComingUpInActivationWindowQuery, FixedActionsComingUpInActivationWindowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FixedActionsComingUpInActivationWindowQuery, FixedActionsComingUpInActivationWindowQueryVariables>(FixedActionsComingUpInActivationWindowDocument, options);
        }
export type FixedActionsComingUpInActivationWindowQueryHookResult = ReturnType<typeof useFixedActionsComingUpInActivationWindowQuery>;
export type FixedActionsComingUpInActivationWindowLazyQueryHookResult = ReturnType<typeof useFixedActionsComingUpInActivationWindowLazyQuery>;
export type FixedActionsComingUpInActivationWindowQueryResult = Apollo.QueryResult<FixedActionsComingUpInActivationWindowQuery, FixedActionsComingUpInActivationWindowQueryVariables>;